import styled, { css } from "styled-components";

export const headerFont = css`
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.1px;
  margin: 0;
`;

export const CardContainer = styled.div`
  display: flex;
  justify-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(48, 44, 44, 0.1);

  ${props => props.theme.aboveBreakpoint} {
    padding: 24px;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 40px 0 24px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;
